import styled from 'styled-components';

export const EmployeePageWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: ${(p) => p.theme?.colors?.white ?? '#ffffff'};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const EmployeeHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.border ?? '#D8DAE5'};
  flex-shrink: 0;

  .ant-typography {
    margin: 0;
  }
`;

/* Flex column wrapper — table fills remaining space, footer stays at bottom */
export const EmployeeTableWrapperStyled = styled.div`
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ant-spin-nested-loading {
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
  }

  .ant-spin-nested-loading > .ant-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

/* Scrollable area for the table rows */
export const EmployeeTableScrollAreaStyled = styled.div`
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  overflow: auto;

  /*
   * table-layout: fixed forces cells to respect explicit column widths.
   * Without this, Ant's auto layout lets long text push columns wider.
   */
  .ant-table {
    table-layout: fixed !important;
  }

  .ant-table-thead > tr > th {
    padding: 12px 16px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    background: ${(p) => p.theme?.colors?.tableHeaderBg ?? '#fafafa'};
  }

  .ant-table-tbody > tr > td {
    padding: 12px 16px;
    font-size: 13px;
    font-weight: 500;
    color: ${(p) => p.theme?.colors?.textPrimary ?? '#2B3034'};
    white-space: normal;
    word-wrap: break-word;
    word-break: break-word;
    vertical-align: top;
  }

  .ant-table-tbody > tr {
    cursor: pointer;
    transition: background 0.15s;

    &:hover > td {
      background: ${(p) => p.theme?.colors?.tableRowHoverBg ?? '#ECE5D8'} !important;
    }
  }

  /* Tags inside cells — allow full text to wrap */
  .ant-table-tbody > tr > td .ant-tag {
    white-space: normal;
    word-break: break-word;
    height: auto;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 4px;
  }

  .employee-incomplete-row {
    background: ${(p) => p.theme?.colors?.warningBg ?? '#FFFBE6'};
  }
`;

/* Fixed pagination footer — always anchored at the bottom */
export const EmployeePaginationFooterStyled = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid ${(p) => p.theme?.colors?.border ?? '#f0f0f0'};
  background: ${(p) => p.theme?.colors?.white ?? '#ffffff'};
`;

export const IncompleteRowClassName = 'employee-incomplete-row';

/* ── Tag style for Profile(s) column ── */

export const FitContentTagStyle = { width: 'fit-content' };
